export const MuiChip = {
  root: {
    borderRadius: '3px',
    fontSize: '0.875rem',
    height: '28px',
  },
  iconSmall: {
    '&.MuiIcon-root': {
      fontSize: '1.25rem',
      width: '1.25rem',
      height: '1.25rem',
      lineHeight: '1.5rem',
    },
  },
  deleteIconSmall: {
    '&.MuiIcon-root': {
      fontSize: '1.35rem',
      width: '1.35rem',
      height: '1.35rem',
      lineHeight: '1.65rem',
    },
  },
  outlined: {
    color: '#363A3D',
  },
  outlinedSecondary: {
    color: '#363A3D',
  },
  colorSecondary: {
    color: '#fff',
  },
};
